import styled, { css } from 'styled-components'
export const StoriesBar = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px 16px 10px 16px;
  overflow-x: auto;
  border-bottom: 1px solid #23243a;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`
export const DiscoverWrapper = styled.div`
  background-color: ${({ theme }) => theme.app.background};
  height: calc(100vh - 65px);
  color: white;
  padding-bottom: 70px;
  @media (min-width: 600px) {
    width: 560px;
    margin: auto;
  }
`

export const ErrorText = styled.div`
  color: red;
  text-align: center;
  margin: 32px;
`

export const RemixIconWrapper = styled.div`
  position: relative;
`

export const Story = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 70px;
`
export const StoryAvatar = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 2px solid #00b8f8;
  object-fit: cover;
  margin-bottom: 4px;
`
export const StoryName = styled.span`
  font-size: 12px;
  color: #cccccc;
  font-weight: 400;
  text-align: center;
  max-width: 64px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
export const FeedContainer = styled.div`
  padding: 0px 12px;
  margin-bottom: 24px;
`
export const FeedCard = styled.div`
  // background: #181828;
  border-radius: 18px;
  padding: 0 0 12px 0;
  box-shadow: ${({ theme }) => theme.app.boxShadow};
  overflow: hidden;
  height: 75vh;
`
export const FeedHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 0 8px 0;
`
export const FeedAvatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 9px;
`
export const FeedUser = styled.div`
  display: flex;
  flex-direction: column;
`
export const FeedUsername = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.app.text};
`
export const FeedDate = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #999999;
  text-align: start;
`
export const FeedFollow = styled.span`
  margin-left: auto;
  color: #00b8f8;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
`
export const FeedImage = styled.img`
  width: 100%;
  // max-height: 260px;
  object-fit: contain;
  background: #222;
  border-radius: 18px;
`
export const FeedCaption = styled.div`
  font-weight: 500;
  font-size: 15px;
  color: #fff;
  margin: 10px 16px 4px 16px;
`
export const FeedTags = styled.div`
  font-size: 13px;
  color: #aaa;
  margin: 0 16px 8px 16px;
`
export const FeedStats = styled.div`
  display: flex;
  gap: 15px;
  font-size: 15px;
  color: #aaa;
  // margin: 0 0 8px 16px;
  align-items: center;
  // background: #181828;
  border-radius: 0 0 16px 16px;
  padding: 10px 0 2px 0;
`
export const FeedStatIcon = styled.img`
  width: 24px;
  height: 24px;
  margin: 0;
  vertical-align: middle;
  transition: width 120ms ease, height 120ms ease, opacity 120ms ease, transform 120ms ease;
  display: block;
  object-fit: contain;
  transform: none;
  ${({ isfavorite }) =>
    isfavorite
      ? css`
          width: 40px;
          height: 40px;
          opacity: 1;
        `
      : css`
          opacity: 0.95;
        `}
  ${({ isSaved }) =>
    isSaved
      ? css`
          width: 18px;
          height: 18px;
          opacity: 1;
        `
      : ''}
`
// filter: ${({ isfavorite, theme }) =>
//     isfavorite ? "none" : theme.app.iconFilter};
export const FeedStatIconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
`
export const FeedStatsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 13px 0 8px 0;
`
export const FeedRemixButton = styled.button`
  position: static;
  margin-left: auto;
  background: #00b8f8;
  color: #fff;
  border: none;
  border-radius: 999px;
  padding: 0 24px 0 16px;
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  box-shadow: 0 2px 8px #00b8f855;
  cursor: pointer;
  gap: 10px;
  z-index: 2;
  max-width: 140px;
  min-width: 0;

  @media (min-width: 600px) {
    max-width: none;
  }
`
export const FeedRemixCornerIcon = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  width: 47px;
  height: 47px;
  z-index: 2;
`
export const ReelsSection = styled.div`
  padding: 0 12px;
  margin-top: 24px;
`
export const ReelsTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 8px;
`
export const ReelsList = styled.div`
  display: flex;
  gap: 14px;
  overflow-x: auto;
  padding-bottom: 8px;
`
export const ReelCard = styled.div`
  width: 186px;
  height: 250px;
  background: #23243a;
  border-radius: 14px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  transition: box-shadow 0.2s;
  box-shadow: 0 2px 8px #0002;
  &:hover {
    box-shadow: 0 4px 16px #00b8f855;
  }
`
export const ReelThumb = styled.img`
  width: 100%;
  height: 160px;
  object-fit: cover;
  background: #222;
`
export const ReelLabel = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  background: #00b8f8;
  color: white;
  border-radius: 6px;
  font-size: 10px;
  padding: 2px 6px;
`
export const ReelTitle = styled.div`
  padding: 8px 8px 4px 8px;
  font-weight: 500;
  font-size: 13px;
  color: #fff;
`
export const FeedImageOverlay = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.05) 40%,
    rgba(0, 0, 0, 0.7) 100%
  );
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  pointer-events: none;
  text-align: start;
`
export const FeedOverlayCaption = styled.div`
  color: #fff;
  font-weight: 600;
  font-size: 15px;
  padding: 0 16px 0 16px;
  text-shadow: 0 2px 8px #000a;
`
export const FeedOverlayTag = styled.div`
  color: #00b8f8;
  font-size: 12px;
  padding: 0 16px 14px 16px;
  text-shadow: 0 2px 8px #000a;
`
export const FeedOverlaySubCaption = styled.div`
  color: #d1d1d1;
  font-size: 17px;
  font-weight: 400;
  padding: 0 16px 18px 16px;
  text-shadow: 0 2px 8px #000a;
`
export const FeedOverlayRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 16px 8px 16px;
`
export const FeedOverlayIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.35);
  color: #fff;
  font-size: 22px;
`
export const FeedBookmarkIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-left: 24px;
  cursor: pointer;
  vertical-align: middle;
`

export const FeedMoreVerticalIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-left: 26px;
  cursor: pointer;
  vertical-align: middle;
  filter: ${({ theme }) => theme.app.iconFilter};
`

export const CustomSeekbarContainer = styled.div`
  @media (min-width: 600px) {
    width: 412px !important;
    height: 44px !important;
    top: 250px !important;
    left: 50% !important;
    right: auto !important;
    bottom: auto !important;
    transform: translateX(-50%) !important;
    position: absolute;
  }
`
export const BackButton = styled.button`
  background: transparent;
  box-shadow: none;
  padding: 0;
  min-width: 0;
  border: none;
  cursor: pointer;
`
export const RadioInput = styled.input`
  border-color:${({ theme }) => theme.app.inputBorder};
  &:checked {
    background-color: ${({ theme }) => theme.app.text};
  }
`
